import React from "react"
import Moment from "../../moment"

const DateTimeCell = ({ value }) =>
  value && value.length > 1 ? <Moment value={value} format="DD MMM YYYY HH:mm" /> : "-"

export default DateTimeCell
